import { alpha } from '@mui/system';
import { themeObject } from 'lib';

export const cancelJobMenuStyles = {
    iconStyles: {
        '&:hover': {
            backgroundColor: themeObject.palette.primary[50],
        },
    },
    menuStyles: {
        '& .MuiPaper-root': {
            width: '165px',
            borderRadius: '20px',
            boxShadow: `
               0px 3px 14px 2px ${alpha(themeObject.palette.grayScale[700], 0.12)},
               0px 8px 10px 1px ${alpha(themeObject.palette.grayScale[700], 0.14)},
               0px 5px 5px -3px ${alpha(themeObject.palette.grayScale[700], 0.2)},
              `,
        },
    },
    menuItemContainerStyles: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    cancelIconStyles: {
        color: themeObject.palette.error[600],
    },
};
